'use client';

import React, { useEffect } from 'react'

import {
    Box,
    VStack,
    Button,
    Stack,
    FormControl,
    Input,
    Textarea,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    useBoolean
} from "@chakra-ui/react"

import { Formik } from 'formik'

import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';

import { HUBSPOT_PORTAL_ID, HUBSPOT_CONTACT_FORM_ID, wait } from '../../../../shared/helpers';

import { isEmpty } from 'lodash'

export const ContactForm = () => {
    const [wasSubmitSuccess, setWasSubmitSuccess] = useBoolean()
    const form = useHubspotForm({
        portalId: HUBSPOT_PORTAL_ID,
        formId: HUBSPOT_CONTACT_FORM_ID,
        target: '#hubspot-contact-form'
    });
    // unmount
    useEffect(() => { return () => setWasSubmitSuccess.off() }, [setWasSubmitSuccess])
    return (
        <Box w="full">
            <Stack spacing={6} ml={1.5}>
                <VStack align="start" spacing={6}>
                    {wasSubmitSuccess && (
                        <Alert status="success" rounded="md" py={3}>
                            <AlertIcon ml={2} />
                            <Stack spacing={0} ml={3}>
                                <AlertTitle>We've got your message!</AlertTitle>
                                <AlertDescription>You'll receive a response from us within 48 hours.</AlertDescription>
                            </Stack>
                        </Alert>
                    )}
                    <Formik
                        initialValues={{}}
                        enableReinitialize
                        onSubmit={async (values, { resetForm }) => {
                            try {
                                await wait(1000)
                                submitHubspotForm({ values });
                                resetForm()
                                setWasSubmitSuccess.toggle()
                            } catch (e) {
                                console.error(e)
                            } finally {
                            }
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            /* and other goodies */
                        }) => {
                            if (!isEmpty(errors)) console.log(errors);
                            return (
                                <form autocomplete="off" onSubmit={handleSubmit} style={{ width: "100%" }}>
                                    <Stack spacing={7} color="fg.default">
                                        <FormControl>
                                            <Input
                                                id="name"
                                                px={4}
                                                size="lg"
                                                rounded="lg"
                                                type="text"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values?.name || ''}
                                                isRequired
                                                placeholder="Name"
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <Input
                                                id="email"
                                                px={4}
                                                size="lg"
                                                rounded="lg"
                                                type="email"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values?.email || ''}
                                                isRequired
                                                autoComplete="off"
                                                placeholder="Email"
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <Textarea
                                                id="content"
                                                size="lg"
                                                fontSize="md"
                                                rounded="lg"
                                                type="text"
                                                overflow="scroll"
                                                onChange={handleChange}
                                                minH="150px"
                                                onBlur={handleBlur}
                                                value={values?.content || ''}
                                                isRequired
                                                placeholder="Your message"
                                            />
                                        </FormControl>
                                        <FormControl id="submit">
                                            <Button borderRadius="full" px={6} isLoading={isSubmitting} size="xl" fontSize="md" fontWeight="medium" type="submit" colorScheme="blue">Submit</Button>
                                        </FormControl>
                                    </Stack>
                                </form>
                            )
                        }}
                    </Formik>
                </VStack>
                <Box id="hubspot-contact-form" display="none !important" />
            </Stack>
        </Box>
    )
}

const submitHubspotForm = ({ values }) => {

    try {

        const hubspotFormDom = document.getElementById(`hsForm_${HUBSPOT_CONTACT_FORM_ID}`)

        /*** bind inputs to hubspot inputs ***/
        // first name
        document.getElementById(`TICKET.name-${HUBSPOT_CONTACT_FORM_ID}`).value = values?.name
        // email
        document.getElementById(`TICKET.email-${HUBSPOT_CONTACT_FORM_ID}`).value = values?.email
        // content
        document.getElementById(`TICKET.content-${HUBSPOT_CONTACT_FORM_ID}`).value = values?.content
        /*** bind inputs to hubspot inputs ***/

        // submit form
        hubspotFormDom.submit();

    } catch (e) {
        throw new Error(e)
    }

}